import { Outlet } from 'react-router-dom';

import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

/**
 * Two-column shell: fixed Sidebar on the left, Topbar + main content on the
 * right. Wraps every authed admin route via the router config in App.tsx.
 */
export function AppShell() {
  return (
    <div className="flex h-screen w-full flex-col bg-background md:flex-row">
      <Sidebar />
      <div className="flex min-h-0 min-w-0 flex-1 flex-col">
        <Topbar />
        <main className="min-h-0 min-w-0 flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
